import { call, put, takeLatest } from 'redux-saga/effects'
import { UserRulesActions, UserRulesTypes } from './userRulesSlice'
import api from '../../services/api'

function* createRulesSaga(action) {
  const response = yield call(api.createUserRules, action.data)
  if (response.ok) {
    yield put(UserRulesActions.createRulesSuccess(response.data))
  } else {
    const error = response.data?.message || response.data?.error || response.problem
    yield put(UserRulesActions.createRulesFailure(error))
  }
}

function* fetchRulesSaga() {
  const response = yield call(api.getUserRules)
  if (response.ok) {
    yield put(UserRulesActions.fetchRulesSuccess(response.data))
  } else {
    const error = response.data?.message || response.data?.error || response.problem
    yield put(UserRulesActions.fetchRulesFailure(error))
  }
}

function* updateRulesSaga(action) {
  const response = yield call(api.updateUserRules, action.data)
  if (response.ok) {
    yield put(UserRulesActions.updateRulesSuccess(response.data))
  } else {
    const error = response.data?.message || response.data?.error || response.problem
    yield put(UserRulesActions.updateRulesFailure(error))
  }
}

export default function* userRulesSaga() {
  yield takeLatest(UserRulesTypes.CREATE_RULES_REQUEST, createRulesSaga)
  yield takeLatest(UserRulesTypes.FETCH_RULES_REQUEST, fetchRulesSaga)
  yield takeLatest(UserRulesTypes.UPDATE_RULES_REQUEST, updateRulesSaga)
}
